export const headCopy = {
  head_playground_title:
    "Playground - An online editor for exploring TypeScript and JavaScript",
  head_playground_description:
    "The Playground lets you write TypeScript or JavaScript online in a safe and sharable way.",
  tsconfig_title: "TSConfig Reference - Docs on every TSConfig option",
  tsconfig_description:
    "From allowJs to useDefineForClassFields the TSConfig reference includes information about all of the active compiler flags setting up a TypeScript project.",
  playground_example_prefix: "Playground Example - ",

  head_index_title: "Typed JavaScript at Any Scale",
  head_index_description: "Typed JavaScript at Any Scale",
}
